/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {
 *         keyId: "key_id"
 *     }
 */
export interface DraftLatestIssueRequest {
    /**
     * From [Zalando RESTful API Guidelines - models/headers-1.0.0.yaml](https://opensource.zalando.com/restful-api-guidelines/models/headers-1.0.0.yaml).
     * The **If-Match** header field is used to declare a list of identifiers that
     * are required to match the current resource version identifier in at least
     * one position as a pre-condition for executing the request on the server
     * side. This behavior is used to validate and reject optimistic updates, by
     * checking if the resource version a consumer has based his changes on is
     * outdated on arrival of the change request to prevent lost updates.
     *
     * If the pre-condition fails the server will respond with status code **412**
     * (Precondition Failed). See [RFC 9110 Section 13.1.1][rfc-9110-13.1.1] as
     * well as [API Guideline Rule #182][api-182] for further details.
     *
     * [rfc-9110-13.1.1]: <https://tools.ietf.org/html/rfc9110#section-13.1.1>
     * [api-182]: <https://opensource.zalando.com/restful-api-guidelines/#182>.
     */
    ifMatch?: string;
    /** The DID method to use for the issuer DID. */
    didMethod?: Truvity.DraftLatestIssueRequestDidMethod;
    /** The URI of the credential issuer. */
    issuer?: string;
    /** The ID of the key to sign the credential. */
    keyId: string;
    /** Map of draft URNs to their associated eTags for validation */
    prerequisiteDrafts?: Record<string, string>;
    /** When enabled, the user must provide the full list of prerequisite draft IDs, and the system enforces this exact prerequisite graph. When disabled, the system automatically determines the dependency graph. */
    strictMode?: boolean;
    /** The date and time the issued credential is valid from. */
    validFrom?: Date;
    /** The date and time the issued credential is valid until. */
    validUntil?: Date;
}
